// Geographic domains (west, south, east, north). No implied sensor coverage.
export const OBSERVATION_AREAS = {
    sicily: { label: 'Sicilia e dintorni', bounds: [10, 34, 18.5, 40], zoomBounds: [[12.38, 36.58], [15.62, 38.32]] },
    italy: { label: 'Italia e isole', bounds: [6, 33, 19, 48], zoomBounds: [[6.3, 35.4], [18.8, 47.2]] },
    world: { label: 'Mondo', bounds: [-180, -85.051129, 180, 85.051129], zoomBounds: [[-180, -65], [180, 75]] },
    europe: { label: 'Europa', bounds: [-25, 33, 60, 72], zoomBounds: [[-25, 33], [60, 72]] },
};

export function visibleObservationBounds(area, view, margin = .25) {
    const domain = OBSERVATION_AREAS[area]?.bounds;
    if (!domain) return null;
    if (!view) return [...domain];
    const [w, s, e, n] = domain;
    const result = [Math.max(w, view[0]-margin), Math.max(s, view[1]-margin),
        Math.min(e, view[2]+margin), Math.min(n, view[3]+margin)];
    return result[0] < result[2] && result[1] < result[3] ? result : null;
}

// A wrapped viewport can cross the antimeridian or lie in another world copy.
// Split it into at most two canonical requests instead of losing Pacific data.
export function visibleObservationWindows(area, view, margin = .25) {
    if (!view) return OBSERVATION_AREAS[area] ? [[...OBSERVATION_AREAS[area].bounds]] : [];
    if (!view.every(Number.isFinite)) return [];
    let [west, south, east, north] = view;
    if (east < west) east += 360;
    west -= margin; east += margin;
    south = Math.max(-85.051129, south-margin);
    north = Math.min(85.051129, north+margin);
    if (south >= north) return [];
    const width = east-west;
    west = ((west+180)%360+360)%360-180;
    const windows = width >= 360 ? [[-180,south,180,north]]
        : west+width <= 180 ? [[west,south,west+width,north]]
        : [[west,south,180,north],[-180,south,west+width-360,north]];
    return windows.map(bounds => visibleObservationBounds(area, bounds, 0)).filter(Boolean);
}
